<template>
      <div no-body class="lku-charges"> 
      <b-row v-if="lkuLoading" class="justify-content-center mb-2"><span style="color:blue;">Loading data ...</span></b-row>
      <b-row v-else>
        <b-col cols="10">
          <b-form-group label-cols=1 label="Filter" >
            <b-form-row>
              <b-col cols="6">
                  <b-form-input v-model="tblData.crewname" placeholder="Employee Name" @keyup.13.native="search()"></b-form-input>
              </b-col>
              <b-col cols="6">
                  <b-input-group>
                    <b-form-input v-model="tblData.crewnik" placeholder="Employee ID" @keyup.13.native="search()"></b-form-input>
                    <b-input-group-append>
                        <b-button class="btn btn-success ml-1" @click="search()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
                    </b-input-group-append>
                  </b-input-group>
              </b-col>
            </b-form-row>
          </b-form-group>
          <b-form-group label-cols=1 >
            <b-form-row>
              <b-col cols="6">
                  <b-form-input v-model="tblData.jabatan" placeholder="Job Title" @keyup.13.native="search()"></b-form-input>
              </b-col>
              <b-col cols="6">
                  <b-input-group>
                    <b-form-input v-model="tblData.departemen" placeholder="Department" @keyup.13.native="search()"></b-form-input>
                    <b-input-group-append>
                      <b-button class="btn btn-secondary ml-1" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button>
                    </b-input-group-append>
                  </b-input-group>
              </b-col>
            </b-form-row>
          </b-form-group>
        </b-col>
      </b-row>
        <b-table
          class="mb-0"
          ref="tblCrew" style="font-size:smaller;" 
          responsive striped hover
          :items="tblData.items"
          :fields="fields"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :key="updatetable" 
          @row-clicked="selectItem"
        >
        </b-table>
      <b-row>
        <b-col cols="4">
          <div class="pt-2">
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
        </div>        
        </b-col>
        <b-col cols="3">            
            <b-row class="ml-2 mt-2">
              <span class="pt-1 pr-2">Limit per page</span>
              <input type="number" style="width:80px;" v-model="tblData.limit"/>
            </b-row>
        </b-col>
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
</template>
<style lang="scss">
  .lku-charges {
    td {
      padding: 0;

      a {
        //   border: 1px solid;
        text-decoration: none;
        display: block;
        padding: 0.5rem 0.75rem;
      }
    }
  }
</style>

<script>
import crew from "../../apis/crew";

export default {
  data() {
    return {
      fields: [
          { key: "crewnik" , 
            label: "Employee ID",
            sortable: true
          },
          { key: "crewname" , 
            label: "Employee Name",
            sortable: true
          },
          {
            key: "jabatan",
            label: "Job Title",
          },
          {
            key: "pangkat",
            label: "Position",
            sortable: true
          },
          {
            key: "departemen",
            label: "Department",
            sortable: true
          },
      ],
      tblData: {
        page: 1,
        limit: 20,
        total: 0,
        sortBy: 'crewname',
        sortDesc: false,terminate:'0'
      },
      lkuLoading:false,
      updatetable:false
    };
  },
  props: ["compcode","formdata"],
  created: async function() {
      this.tblData.compcode=this.compcode || '';
      if (this.compcode) {
        if (this.formdata.items)
        {
          if (this.formdata.items[0].compcode!==this.compcode) {
            this.data();
          } else {
            for (var key in this.formdata) {
                this.tblData[key] = this.formdata[key];
            }
          }
        } else {
          this.data();
        }
      } else {
        if (this.formdata.items)
        {
            for (var key in this.formdata) {
                this.tblData[key] = this.formdata[key];
            }
        } else {
          this.data();
        }
      }
  },
  computed: {
    filtercompcode() {
      return this.tblData.compcode;
    },
    pagechange() {
      return this.tblData.page;
    },
    limitchange() {
      return this.tblData.limit;
    },
  },
  watch: {
    filtercompcode: function(newval) {
      this.$emit('update:compcode', newval);
    },   
    pagechange: function(newval) {
      this.tblData.page=newval;
      this.refresh();
    },   
    limitchange: function(newval) {
      this.data();
    },   
    "tblData.sortBy": function(newval) {
      this.data();
    },   
    "tblData.sortDesc": function(newval) {
      this.data();
    },   
  },

  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.tblData.compcode=this.compcode;
      this.lkuLoading=true;
      const list = await crew.list(this.tblData);      
      this.lkuLoading=false;
      this.tblData.items=list;
      this.updatetable=!this.updatetable;
    },
    selectItem(item,index) {
      // this.$emit("click", item);
      this.tblData.selected=item;
      this.$emit("click", this.tblData);
    },
    clearFilter() {
        this.tblData={crewnik:'', crewname: '', jabatan: '', department: ''};
    },    
    keymonitor: function(event) {
       if(event.key == "Enter")
       {
        this.$refs.tblCrew.refresh();
       }
    },    
    refresh() {
      this.data();
      this.$refs.tblCrew.refresh();
    },
    search() {
      this.tblData.page=1
      this.data();
      this.$refs.tblCrew.refresh();
    }
  }
};
</script>
